export default __webpack_public_path__ + "src/assets/images/light/light_US.png?451057b5";